import sanitize from "helpers/sanitize";
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { toast } from "helpers/toast";
import { saveUser } from "store/userSlice";
import { useTranslation } from "translation/useTranslation";
import { Button, Modal } from "components/ui";

export default function ReleaseNotes({ notes }) {
  const hasReleaseNotes = typeof notes?.release_notes === 'string'
    ? notes.release_notes.trim().length > 0
    : Boolean(notes?.release_notes);

  const [show, setShow] = useState(hasReleaseNotes);

  const { translate, editableTranslate } = useTranslation();

  const dispatch = useDispatch();

  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    document.body.style.overflowY = (show ? 'hidden' : 'auto');
  }, [show]);

  const handleClose = async () => {
    setShow(false);

    if (dontShow) {
      try {
        await dispatch(saveUser({ show_release_notes: false })).unwrap();
        toast.success(translate('form.success.saved'));
      } catch (err) {
      }
    }
  };

  return <>
    {
      hasReleaseNotes && <>
        <Modal
          open={!!show}
          size="lg"
          title={editableTranslate('release_notes.title')}
          onClose={handleClose}
          testIdPrefix="release-notes-"
          footer={<>
            <div className="peb-modal__footer-start form-check">
              <input type="checkbox" className="form-check-input" id="release-notes-checkbox" checked={dontShow} onChange={(e) => setDontShow(e.target.checked)} data-testid="release-notes-dont-show" />
              <label className="form-check-label ml-1" htmlFor="release-notes-checkbox">{editableTranslate('release_notes.checkbox_label')}</label>
            </div>
            <Button variant="secondary" onClick={handleClose} data-testid="release-notes-close-action">{editableTranslate('button.close')}</Button>
          </>}
        >
          <div dangerouslySetInnerHTML={{ __html: sanitize(notes.release_notes) }} />
        </Modal>
      </>
    }
  </>
}
